import useRedirectFromQueryString from './useRedirectFromQueryString'

export default useRedirectFromQueryString
